/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React, { useContext } from "react";

import { bem } from "../../../shared/BEM";
import { renderFormElementList } from "./renderFormElement";
import { FormSectionGroup } from "../../../shared/FormModel/elements/FormSectionGroup";
import { useFormElement } from "../../../shared/hooks/useFormElement";
import { ConfigContext } from "../../ConfigContext";

/**
 * Component props
 */
export interface IFormSectionGroupComponentProps {
	element: FormSectionGroup
}

export function FormSectionGroupComponent(props: IFormSectionGroupComponentProps) {

	const configCtx = useContext(ConfigContext);
	const state = useFormElement(props.element);

	if (!state.display) {
		return null;
	}

	if (configCtx.mode === "ssr" && state.config.print === false) {
		return null;
	}

	const mods = [];

	if (state.config.spaceBefore) {
		mods.push("space-before");
	}

	if (state.config.spaceAfter) {
		mods.push("space-after");
	}

	const stl = bem("form-section-group", null, mods);

	return <div className={stl.str}>
		{renderFormElementList(state.content)}
	</div>;

}